import { z } from 'zod';

export const UpdatePasswordSchema = z.object({
  password: z.string().optional(),
  password_confirmation: z.string().optional(),
}).refine((data) => {
  if (data.password || data.password_confirmation) {
    return data.password === data.password_confirmation;
  }
  return true;
}, {
  message: "Passwords don't match",
  path: ["password_confirmation"],
});